<template>
    <div>
        <htmlHeader :top_index="5" :menuCode="false" :crumbsShow="false" />
        <div class="caigou">
            <div class="caigoukuang">
                <div class="caigoubiaoti">
                    <div style="padding:40px 0 0 38px">
                        <p>文档下载</p>
                        <!-- <p class="caigoufubiaoti">把您的需求告诉科隆，我们来为您完成</p> -->
                    </div>
                    <div style="margin:auto;padding:20px 40px 0 40px;position: relative;">
                        <div class="buzhoubox">
                            <span class="buzhou">选择文档类型</span>
                            <div class="buzhou-cont">
                                <a-radio-group v-model:value="form.filetype">
                                    <a-radio v-for="(item, index) in all_filetype" :key="index"
                                        :value="item.name" @click="filetype_change(index)">{{
                                                item.name
                                        }}</a-radio>
                                </a-radio-group>
                                <!-- <div :key="index" v-for="(item, index) in all_filetype"
                                    style="float:left;margin-right:10px"
                                    :style="form.filetype == item.name ? 'color:#2b9a34' : ''"
                                    @click="filetype_change(index)">
                                    {{ item.name }}
                                </div> -->
                            </div>
                        </div>
                        <div style="border-top:1px solid #EDE9E9;height:1px;width:596px;margin:8px auto;"></div>
                        <div>
                            <a-input placeholder="请输入商品名称"
                                style="margin:0 0 15px 0; width:493px; height:32px;border-radius:0"
                                v-model="form.productName" @change="findName" />
                            <button class="searchBtn" @click="search">搜索</button>
                        </div>
                        <div v-if="form.filetype != 'MSDS'">


                            <a-input placeholder="请输入批号"
                                style="margin:0 0 8px 0; width: 160px; height:32px;border-radius:0"
                                v-model="form.pihao" />
                            <a-select style="width:160px" :value="form.jibie ? form.jibie : '选择级别'" default-value="选择级别"
                                @change="jibie_change">
                                <a-select-option :key="index" v-for="(item, index) in all_jibie" :value="item">
                                    {{ item }}
                                </a-select-option>
                            </a-select>
                            <a-select style="width:160px" :value="form.pinpai ? form.pinpai : '选择品牌'"
                                default-value="选择品牌" @change="pinpai_change">
                                <a-select-option :key="index" v-for="(item, index) in all_pinpai" :value="item">
                                    {{ item }}
                                </a-select-option>
                            </a-select>


                        </div>
                        <div class="list" v-show="findNameShow">
                            <div class="item" v-for="(item, index) in findNameList" @click="checkName(index)">
                                <div class="cont" >{{ item }}</div>
                            </div>

                        </div>
                        <div style="border-top:1px solid #EDE9E9;height:1px;width:596px;margin:18px auto"></div>
                        <div>
                            <a-table :columns="columns" :data-source="data" :pagination="false">
                                <template slot="handel" slot-scope="text, record">
                                    <a href="javascript:;" @click="onDownload(record)">下载文档</a>
                                </template>
                            </a-table>
                            <template>
                                <!-- v-model:current="current" -->
                                <a-pagination style="margin-top:20px;float:right;" :current="page" :pageSize="5"
                                    @change="pagecurrent" :total="form.total" show-less-items />
                            </template>
                        </div>

                    </div>
                </div>
                <img src="../assets/caigou/right.png" alt="" />
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'News',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            page: 1,
            all_filetype: [{// 所有文件类型
                name: 'COA',
            }, {
                name: 'MSDS',
            },],
            all_jibie: [],// 所有级别
            all_pinpai: [],// 所有品牌
            findNameShow: false,
            findNameList: [],
            form: {
                page: 0,
                size: 5,
                total: 0,
                filetype: 'COA',
                productName: '',
                jibie: '',
                pihao: '',
                pinpai: ''
            },
            data: [
                // {
                //     key: '1',
                //     name: 'John Brown',
                // },
                // {
                //     key: '2',
                //     name: 'Jim Green',
                // },
            ],
            columns: [
                {
                    title: '文档名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                },
                {
                    title: '操作',
                    dataIndex: 'handel',
                    scopedSlots: { customRender: 'handel' },
                },
            ],
        };
    },
    created() {
        this.search()
        this.api.get_goods_type_pinpai().then(res => {
            this.all_pinpai = res.data
            // console.log('品牌', res);
        });
        this.api.get_goods_type_jibie().then(res => {
            this.all_jibie = res.data
            // console.log('ji界别', res);
        });
    },
    methods: {
        onDownload(item) {
            console.log('下载', item);
            window.open('/api/fileNew/download/' + item.fileId, '_blank');
        },
        search() {

            this.api.get_file_list(this.form).then(res => {
                console.log(res);
                this.data = res.data.content
                this.form.total = res.data.totalElements
            });

        },
        pagecurrent(e) {
            this.form.page = e - 1
            this.page = e
            this.search()
        },
        findName() {
            // this.form.productName == '' ? this.findNameShow = false : this.findNameShow = true
            if (this.form.productName !== '') {
                this.api.get_shop_list(this.form.productName).then(res => {
                    this.findNameList = res.data
                    this.findNameList.length > 0 ? this.findNameShow = true : this.findNameShow = false
                });
            } else {
                this.findNameShow = false
            }

        },
        checkName(i) {
            
            this.form.productName = this.findNameList[i]
            this.findNameShow = false
        },
        filetype_change(e) {
            console.log(e);
            if (e === 0) {
                this.form.filetype = 'COA';
            } else {
                this.form.filetype = 'MSDS';
                this.form.jibie = ''
                this.form.pihao = ''
                this.form.pinpai = ''
            }

            this.search()
        },
        shopname_change(e) {
            this.form.productName = e;
        },
        jibie_change(e) {
            this.form.jibie = e;
            this.search()

        },
        pihao_change(e) {
            this.form.pihao = e;
        },
        pinpai_change(e) {
            this.form.pinpai = e;
            this.search()
        },
    }
};
</script>

<style scoped>
/deep/ .ant-table-thead>tr>th {
    padding: 8px 8px !important;
}

/deep/ .ant-table-tbody>tr>td {
    padding: 8px 8px !important;
}

.list {
    width: 250px;
    height: 150px;
    overflow: auto;
    border: 1px solid #EDE9E9;
    position: absolute;
    top: 130px;
    background: white;
    z-index: 999;
}

.list::-webkit-scrollbar {
    /* width: 0px; */
    /* height: 0px; */
    /* display: none; */
}

.item {
    cursor: pointer;
    width: 100%;
    height: 32px;
    border-bottom: 1px solid #EDE9E9;
    padding: 0px 10px;
    display: flex;
    justify-content: space-between;
}

.cont {
    line-height: 28px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    overflow: hidden;
}

.download {
    line-height: 28px;
    color: #1890ff;
    font-size: 14px;
    cursor: pointer;
}

p {
    padding: 0;
    margin: 0;
}

.caigou {
    background-image: url(../assets/caigou/bg.png);
    width: 100%;
    height: 790px;
    padding: 112px 0;
}

.caigoukuang {
    width: 1000px;
    height: 567px;
    background: #ffffff;
    border-radius: 10px;
    margin: auto;
    display: flex;
    justify-content: space-between;
}

.caigoubiaoti {
    width: 650px;
    height: 44px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
}

.caigoufubiaoti {
    width: 500px;
    height: 44px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
}

.buzhoubox {

    display: flex;
    justify-content: space-between;
}

.buzhou {
    width: 150px;
    font-size: 14px;
    font-weight: bold;
    margin-right: 10px;
}

.buzhou-cont {
    width: 500px;
    font-size: 14px;
    cursor: pointer;
    /* display: flex;
    justify-content: space-between; */
}

.buzhou::before {
    content: '* ';
    color: red;
}

.searchBtn {
    display: block;
    float: right;
    margin-top: 4px;
    width: 64px;
    height: 32px;
    line-height: 32px !important;
    text-align: center;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    font-weight: 400;
    color: #2b9a34;
    line-height: 16px;
    cursor: pointer;
    outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue